import React, { Component } from 'react'
import { Button, Card, Form, Input, PageHeader, Typography, message } from 'antd'
import { AdoptionApplicationConsumer } from '../../context/AdoptionApplicationContext'
import { adoptionApplicationForceSetAvailable } from 'services/api'

export default class AdoptionPetSetAvailable extends Component {

  render() {

    return (
              <AdoptionApplicationConsumer>
                {({ fetching, error,requestAdoptionApplicationForceSetAvailable }) => {

                  
                  return (
                    <Card>
                      <PageHeader title="Forcefully set pet to AVAILABLE status" >
                        <Typography.Text>Use this feature whenever a shelter asks Customer Support to fix a pet that is Stuck in APPROVED while there is no Application under Approved, Signed, or Paid. Get the Pet’s UUID from the URL in their public profile, paste it here, and submit it to revert its status to AVAILABLE.</Typography.Text>
                        <br/><br/>
                      <Form
                        name="basic"
                        style={{ maxWidth: 600 }}
                        initialValues={{ remember: true }}
                        onFinish={async (val) => {
                          let response = await adoptionApplicationForceSetAvailable(val)
                          console.log(response)
                          if(response?.data?.status === 200){
                            message.success(`pet update successfully!`);
                          }else{
                            message.error(`we cant set this pet available!`);
                          }
                          
                        }}
                        autoComplete="off"
                      >
                        <Form.Item
                          label="Pet uuid"
                          name="uuid"
                          rules={[{ required: true, message: 'Please input your pet uuid!' }]}
                        >
                          <Input />
                        </Form.Item>

                        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                          <Button type="primary" htmlType="submit">
                            Submit
                          </Button>
                        </Form.Item>
                      </Form>
                      </PageHeader>
                      
                    </Card>
                  )
                }}
              </AdoptionApplicationConsumer>
            )
          }
        }